import React from 'react';
import AdminLayout from '../components/AdminLayout';
import EligibilityChecker from '../components/EligibilityChecker';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// DoorlyDesk's copy of the partner portal's buyer-eligibility check.
//
// ⚠️ IT IS THE SAME COMPONENT AND THE SAME BACKEND HANDLER, not a reimplementation.
// Staff answering a partner's "would this buyer qualify?" must see exactly what
// the partner sees; two implementations of the AFM matrix would drift silently
// and the first symptom would be a staff member contradicting the portal.
//   component : components/EligibilityChecker.jsx  (matrix from GET /api/uw-matrix)
//   chat      : POST /api/admin/partners/eligibility-chat, which mounts the
//               exported handler from routes/doorlypro.js under requireAdmin.
//
// ⚠️ AdminLayout IS APPLIED HERE, BY EACH PAGE. An earlier comment in this file
// claimed App.js already wrapped /admin/* routes and that wrapping again would
// nest the chrome. That was wrong, and it shipped a page with no header and no
// left nav — every sibling (AdminREReferrals, AdminREAccounts, …) imports
// AdminLayout and wraps itself, and App.js wraps nothing. The wrong comment is
// what made the omission look deliberate, which is why it survived review.
//
// ⚠️ audience="staff" IS COPY ONLY. A partner asks about THEIR buyer; a partner
// success manager asks about someone else's, so "check if your buyer is a fit"
// quietly tells a staff reader they are the referrer. The matrix, the endpoint
// and the guidance are identical.
export default function AdminPartnerEligibility() {
  // ── 🔑 THE TARGET COMES FROM AN ADMIN ROUTE, ON THE ADMIN PAGE ────────────
  // GET /admin/service-area/basis is behind requireAdmin and returns `licence`,
  // which carries the target. The partner page has no equivalent fetch and no
  // prop to receive one — the split is structural, not a render condition.
  const [licenceNote, setLicenceNote] = React.useState(null);
  React.useEffect(() => {
    const t = localStorage.getItem('doorly_admin_token');
    if (!t) return undefined;
    let alive = true;
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/admin/service-area/basis`,
      { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((b) => {
        if (!alive || !b) return;
        const pend = b.standing?.key === 'pending' ? b.licence : null;
        if (pend?.target) setLicenceNote(`${b.state} licence target ${pend.target}. Relay verbally with the caveat that the date is not ours to control.`);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const token = localStorage.getItem('doorly_admin_token');
  return (
    <AdminLayout>
      {/* ⚠️ detail — staff additionally see the licence standing, which counties
            answered and whether each is rural, and WHICH YEAR'S RULE produced
            the answer. Additive only: the partner view above renders the same
            component with detail off. */}
        <EligibilityChecker
        token={token}
        chatEndpoint={`${API_URL}/api/admin/partners/eligibility-chat`}
        audience="staff"
        licenceNote={licenceNote}
      />
    </AdminLayout>
  );
}
